export interface Notification {
  id: number;
  title: string;
  message: string;
  route?: string;
  creationtime: string;
  readtime: string | null;
}
